module.exports = __webpack_public_path__ + "static/img/qa.374e6eca.jpg";